// extracted by mini-css-extract-plugin
module.exports = {"root":"Errors_root__aGAZw","errors":"Errors_errors__27uo7"};